import React, {useEffect, useState} from 'react'
import {getAssay, getPayment} from "@cabinet-packages/api/api";
import EditDateDialog from "../DialogComponents/datePicker/EditDateDialog";
import EditDepartmentDialog from "../DialogComponents/departmentSelector/EditDepartmentDialog";
import {CabinetAccordion, CabinetAccordionDetails, CabinetAccordionSummary} from "../../settings/cabinetAccordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CancelIcon from "@material-ui/icons/Clear";
import DownloadIcon from "@material-ui/icons/GetApp";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import {getPriceContainer} from "../../utils/PricePattern";
import {Grid, useMediaQuery} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {CustomDialog, RefundDialog} from '@cabinet-packages/components';
import {addAssayToOrderList, getClientLocation} from "@cabinet-packages/redux";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    accordionRoot: {
        margin: '14px 0px !important'
    },
    summaryContent: {
        display: 'grid',
        gridTemplateColumns: '0.5fr 0.5fr 1.2fr 2fr 0.7fr',
        margin: '12px 0px !important',
        '& > div': {
            fontSize: '14px',
        },
        '@media(max-width: 900px)': {
            display: 'flex',
            flexWrap: 'wrap',
            height: 'max-content',
            rowGap: '5px'
        }
    },
    accordionExpanded: {
        boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
        height: 'min-content',
        margin: '10px 0px !important'
    },
    servicesContainer: {
        display: 'grid',
        gridTemplateColumns: '6fr 1fr',
        height: '40px',
        backgroundColor: '#F8F9F9',
        padding: '10px',
        margin: '10px 0px',
        position: 'relative',
        '& > div': {
            fontSize: '15px',
            '@media(max-width: 900px)': {
                fontSize: '12px'
            }
        },
        '@media(max-width: 900px)': {
            gridTemplateColumns: '3fr 1fr',
            height: 'min-content',
        }
    },
    columnLabelsContainer: {
        display: 'grid',
        gridTemplateColumns: '0.5fr 0.5fr 1.5fr 1.5fr 1fr',
        height: '15px',
        padding: '0px 16px',
        '@media(max-width: 900px)': {
            display: 'none'
        }
    },
    servicesLabelsContainer: {
        display: 'grid',
        gridTemplateColumns: '6fr 1fr',
        height: '15px',
        padding: '0px 10px',
        '@media(max-width: 900px)': {
            gridTemplateColumns: '3fr 1fr',
        }
    },
    columnLabel: {
        fontSize: '12px',
        fontWeight: 500,
        color: theme.palette.grey.text,
        '@media(max-width: 900px)': {
            fontSize: '9px'
        }
    },
    buttons: {
        borderRadius: '2rem',
        border: `1px solid #0E4E4E`,
        fontSize: '14px',
        fontWeight: 600,
        height: '30px',
        color: theme.palette.colors.text,
        width: '50%',
        transition: '0.5s',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#F8F9F9'
        },
        '@media(max-width: 900px)': {
            fontSize: '12px'
        }
    },
    buttonsContainer: {
        display: 'flex',
        columnGap: '5px',
        justifyContent: 'center'
    },
    divider: {
        backgroundColor: '#eaeaea',
        height: '1px',
        border: 0,
        margin: '20px 0px'
    },
    cancelIcon: {
        position: 'absolute',
        right: 5,
        top: 10
    }
}));

const OrderAccordion = ({order, expanded, active, setExpanded}) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))
    const [punkt, setPunkt] = useState(null)
    const { punkts } = useSelector(store => store.collectionPoints)
    const { themeMaterialUI } = useSelector(store => store.theme);
    const { activePatient, activePatientsOrders } = useSelector(state => state.patients);
    const {catalog, complexResearch}  = useSelector(state => state.assaysCatalog);
    const [isEdit, setEdit] = useState(false)
    const [isRefund, setRefund] = useState(false)
    const editMode = isEdit || isRefund
    const [init, setInit] = useState(false)
    const [localExpanded, setLocalExpanded] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        if(punkts && punkts !== "error") {
            punkts.forEach((item) => {
                if (item.idPunkt === order.idPunkt) {
                    setPunkt(item)
                }
            })
        }
        setInit(true)
    }, [punkts, activePatientsOrders])

    const showRefundDialog = (event, isOrder, item) => {
        CustomDialog(RefundDialog, {
            order: isOrder ? item : null,
            service: isOrder ? null : item,
            punkt,
            headerText: "Повернення коштів"
        }, event, themeMaterialUI);
    };

    const showCancelDialog = (event, order) => {
        CustomDialog(RefundDialog, {
            order,
            punkt,
            headerText: "Скасування візиту"
        }, event, themeMaterialUI);
    };

    const handleDownloadPDF = async (event, orderID) => {
        const res = await getPayment(orderID);

        const url = window.URL.createObjectURL(new Blob([res], {type: 'application/pdf'}));

        const link = document.createElement('a');
        link.href = url;
        link.download = `${activePatient && activePatient.lastname && activePatient.lastname}_${activePatient && activePatient.firstname && activePatient.firstname}_${activePatient && activePatient.fathername && activePatient.fathername}_замовлення_${orderID}.pdf`;
        link.click();
        link.remove()
    }

    const handleEditClick = () => {
        setEdit(!isEdit)
        localStorage.setItem("idReg", punkt.idCity)
        dispatch(getClientLocation(punkt))
    }

    const handleRefundClick = () => {
        setRefund(!isRefund)
    }

    const showEditDateDialog = (event) => {
        CustomDialog(EditDateDialog, {
            order,
            punkt
        }, event, themeMaterialUI);
    };

    const showEditAddressDialog = (event) => {
        CustomDialog(EditDepartmentDialog, {
            order,
            punkt
        }, event, themeMaterialUI);
    };

    const handleCancelClick = () => {
        setEdit(false)
        setRefund(false)
    }

    const handleSaveClick = () => {
        setEdit(false)
        setRefund(false)
    }

    const handleRepeatOrder = async (e, orderId) => {
        e.preventDefault();
        e.stopPropagation();
        //setLoading(orderId);
        //setError(null);

        try {
            const {data} = await getAssay(orderId);

            const foundedAssays = data.reduce((acu, cur) => {
                let foundedAssay;
                if (cur.complex) {
                    foundedAssay = complexResearch.find(item => +item.id === +cur.id && item.code === cur.code);
                } else {
                    foundedAssay = catalog.find(item => +item.id === +cur.id && item.code === cur.code);
                }

                if (foundedAssay) {
                    return [...acu, foundedAssay];
                } else {
                    return acu;
                }
            }, []);

            if (foundedAssays && foundedAssays.length > 0) {
                foundedAssays.forEach(item => {
                    dispatch(addAssayToOrderList(
                        item.id,
                        item.discount
                            ? item.price - item.price * item.discount / 100
                            : item.price,
                        () => {
                        },
                        item.type
                    ))
                })
                history.push('/order-manager');
            } else {
                console.log("ERROR" + e)
                setError(true)
            }
        } catch (e) {
            console.log("ERROR" + e)
            setError(true)

        }

        //setLoading(null);
    };

    const handleChange = () => {
        setLocalExpanded(!localExpanded)
    }

    return (
        <>
            {init && (
                <CabinetAccordion
                    elevation={0}
                    expanded={localExpanded}
                    onChange={handleChange}
                    TransitionProps={{
                        timeout: 0
                    }}
                    key={order.id}
                    classes={{root: classes.accordionRoot}}
                >
                    <CabinetAccordionSummary
                        expandIcon={!isRefund ? <ExpandMoreIcon fontSize={"small"} color={"primary"}/> : <CancelIcon color={"error"} fontSize={"small"} onClick={(e) => showRefundDialog(e, true, order)}/>}
                        classes={{content: classes.summaryContent}}
                    >
                        {active ? (
                            <DownloadIcon onClick={(event) => {
                                event.stopPropagation();
                                handleDownloadPDF(event, order.id)
                            }}
                                          color={order.paymentStatus === "PAYED" ? 'primary' : 'disabled'}
                                          style={mdUp ? {} : {position: 'absolute', top: 15, right: 15}}/>
                        ) : <div></div>}
                        <Typography color={active ? 'textPrimary' : 'textSecondary'} style={mdUp ? {} : {order: 0, flex: '1 0 20%'}} component={"div"}>
                            {order.id}
                        </Typography>
                        <Typography style={{position: 'relative', display: 'flex', alignItems: 'center', textDecoration: isEdit && expanded === order.id ? 'underline' : 'none', order: 0, flex: mdUp ? '' : '1 0 80%'}}  color={active ? 'textPrimary' : 'textSecondary'} component={"div"}>
                            <span>{order.dt.slice(8, 10) + "." + order.dt.slice(5, 7) + "." + order.dt.slice(0, 4)}</span>
                            {isEdit && localExpanded && (
                                <EditIcon style={mdUp ? {position: 'absolute', right: 5, fontSize: '1rem'} : {position: 'absolute', marginLeft: '7px', fontSize: '1rem'}}
                                          color={'error'}
                                          onClick={showEditDateDialog}
                                />
                            )}
                        </Typography>
                        <Typography style={{position: 'relative', paddingRight: '20px', display: 'flex', alignItems: 'center', textDecoration: isEdit && expanded === order.id ? 'underline' : 'none', order: mdUp ? 0 : 3, flex: mdUp ? '' : '1 0 100%'}} color={active ? 'textPrimary' : 'textSecondary'} component={"div"}>
                            <span>{punkt && punkt.address}</span>
                            {isEdit && localExpanded && (
                                <EditIcon style={mdUp ? {position: 'absolute', right: 10, fontSize: '1rem'} : {position: 'absolute', marginLeft: '5px', fontSize: '1rem'}}
                                          color={'error'}
                                          onClick={showEditAddressDialog}/>
                            )}
                        </Typography>
                        {order.price ? (
                            <div style={mdUp ? {} : {order: 4, flex: '1 0 100%'}}>
                                {getPriceContainer(order.price, active, true)}
                            </div>
                        ) : (<div></div>)}
                    </CabinetAccordionSummary>
                    <CabinetAccordionDetails>
                        {order?.services && order?.services.length !== 0 && (<div>
                                <div className={classes.servicesLabelsContainer}>
                                    <Typography className={classes.columnLabel}>
                                        Замовлені дослідження
                                    </Typography>
                                    <Typography className={classes.columnLabel}>
                                        Ціна онлайн
                                    </Typography>
                                </div>
                                {order?.services.map((service, idx) => {
                                    return (
                                        <div className={classes.servicesContainer}
                                             key={service.id + ' ' + idx}
                                        >
                                            <Typography component={'div'} color={active ? 'textPrimary' : 'textSecondary'}>
                                                {service.name}
                                            </Typography>
                                            {getPriceContainer(service.price, active, mdUp)}
                                            {isRefund && (
                                                <CancelIcon className={classes.cancelIcon} color={"error"} fontSize={"small"} onClick={(e) => showRefundDialog(e, false, service)}/>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                        <hr className={classes.divider}/>
                        <Grid container alignItems={"center"} spacing={mdUp ? 2 : 1}>
                            <Grid item xs={mdUp ? 6 : 12}>
                                <Typography color={"error"} style={{fontSize: '12px', fontWeight: 400}}>
                                    {!editMode ? "За умови непередбачуваних обставин, Ви маєте можливість скасувати запис або змінити дату замовлення" :
                                        isRefund ? "Оберіть аналізи за які Ви хочете повернути кошти" : "Редагуйте дату та час, а також відділення"}
                                </Typography>
                            </Grid>
                            <Grid item xs={mdUp ? 6 : 12}>
                                {active ? (
                                    <div className={classes.buttonsContainer}>
                                        <Button className={classes.buttons} onClick={() => {
                                            !editMode ? handleEditClick() : handleCancelClick()
                                        }}>
                                            {!editMode ? "Редагувати візит" : "Скасувати"}
                                        </Button>
                                        {order?.services && order?.services?.length !== 0 ? (
                                            <Button className={classes.buttons} onClick={() => {
                                                // !editMode ? handleRefundClick() : handleSaveClick()
                                            }}>
                                                {!editMode ? "Повернення коштів" : "Зберегти"}
                                            </Button>
                                        ) : (
                                            <Button className={classes.buttons} onClick={(e) => showCancelDialog(e, order)}>
                                                Скасування візиту
                                            </Button>
                                        )}
                                    </div>
                                ) : (
                                    <div className={classes.buttonsContainer}>
                                        {/*<Button className={classes.buttons} onClick={(e) => showRefundDialog(e, true, order)}>*/}
                                        {/*    Повернення коштів*/}
                                        {/*</Button>*/}
                                        {error
                                            ? <p style={{color: 'red'}}>Вибачте, дане замовлення не можна замовити повторно.</p>
                                            : <Button className={classes.buttons}
                                                 onClick={(e) => handleRepeatOrder(e, order.id)}>
                                            Замовити повторно
                                        </Button>}
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </CabinetAccordionDetails>
                </CabinetAccordion>
            )}
        </>
    )
}

export default OrderAccordion;